import { dayWindowToParams, type DayWindow } from '@/lib/dates/day-window'

/**
 * Paths for Transfer Audits (web-portal#71). The window searched rides
 * along as `?from=&to=`, so the list reopens on it and an audit opened from
 * it knows where Back goes.
 */
export const TRANSFER_AUDITS_PATH = '/admin/inventory/transfer-audits'

function withWindow(path: string, window: DayWindow | null): string {
  if (!window) return path
  return `${path}?${new URLSearchParams(dayWindowToParams(window)).toString()}`
}

/** The list, opened on a window when one is given. */
export function transferAuditsPath(window: DayWindow | null = null): string {
  return withWindow(TRANSFER_AUDITS_PATH, window)
}

/** One audit, opened from a list searched over `window`. */
export function transferAuditDetailPath(
  transferId: string,
  auditUuid: string,
  window: DayWindow | null = null
): string {
  const path = `${TRANSFER_AUDITS_PATH}/${encodeURIComponent(transferId)}/${encodeURIComponent(auditUuid)}`
  return withWindow(path, window)
}
